import { type PaymentFilter } from '../../models/Payment';

export interface PaymentOption {
  id: string;
  name: string;
}

export interface PaymentFilterForm {
  tin?: string;
  taxCollector?: PaymentOption;
  jurisdiction?: PaymentOption;
  status?: PaymentOption;

  dateFrom?: Date;
  dateTo?: Date;

  amountFrom?: number;
  amountTo?: number;
}

export const DEFAULT_RELATIONS = [
  'Currency',
  'PaymentMethod',
  'TaxReturn',
  'TaxReturn.Taxpayer',
  'ReconciliationOfPayments.PaymentsReceived.PaymentReceived'
];

export const PAYMENT_STATES = ['pending', 'rejected', 'reconciled'];

export const mapPaymentFormToSearch = (values: PaymentFilterForm): PaymentFilter => ({
  tin: values.tin,
  status: values.status?.id,
  dateFrom: values.dateFrom,
  dateTo: values.dateTo,
  amountFrom: values.amountFrom,
  amountTo: values.amountTo
});
